import Box from '@mui/material/Box';
import { get } from 'lodash';
import { useEffect } from 'react';
import { useStore, useTranslate } from 'react-admin';
import { Outlet, useParams } from 'react-router';
import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import { AVATARS, CURRENT_CLIENT_NAVIGATION_STORE_KEY } from '@/utils/CONST';
import CustomBlock from '@/components/common/custom-block/custom-block';
import DashboardsInfoBox from '@/components/common/dashboards-info-box/dashboards-info-box';
import SiteDetails from '@/components/site/site-details';

const SiteInformation = () => {
    const translate = useTranslate();
    const { siteId } = useParams();
    const { avatar, isLoading } = useGetAvatar({
        avatarUriId: composeUri(AVATARS, siteId),
        filters: {
            'serialization_groups[0]': 'read_avatar_root',
            'serialization_groups[1]': 'read_parent',
            'serialization_groups[2]': 'read_avatar_parent',
        },
    });
    const [, setCurrentClientNavigation]: any = useStore(CURRENT_CLIENT_NAVIGATION_STORE_KEY, undefined);

    useEffect(() => {
        if (avatar) {
            setCurrentClientNavigation(get(avatar, 'parent.@id'));
        }
    }, [avatar]);

    return (
        <Box
            data-cy='site-information-container'
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateColumns: '1fr 400px',
                gridTemplateRows: '1fr',
                height: '100%',
                overflowY: 'auto',
            }}
        >
            <CustomBlock label={avatar?.name} loading={isLoading}>
                <Box
                    sx={{
                        p: 1,
                        display: 'grid',
                        gap: 3,
                        alignContent: 'start',
                        justifyContent: 'center',
                    }}
                >
                    {avatar && (
                        <DashboardsInfoBox
                            avatar={avatar}
                            params={{
                                site_id: siteId,
                            }}
                            clientOrSite='site'
                        />
                    )}
                </Box>
            </CustomBlock>

            <CustomBlock label={translate('main.details')} loading={isLoading}>
                <Box
                    sx={{
                        display: 'grid',
                        height: '100%',
                        overflowY: 'auto',
                        alignContent: 'start',
                    }}
                >
                    <SiteDetails />
                </Box>
            </CustomBlock>

            <Outlet />
        </Box>
    );
};

export default SiteInformation;
